<template>
  <b-col
    class="card-header-block"
    :class="customClass"
  >
    <div
      v-if="patient"
      class="patient-header"
    >
      <div class="text-center d-flex align-items-center justify-content-center py-2">
        <p>
          <span class="ap-title ap-title__section">
            <i
              class="mr-2 fal fa-user-circle"
              aria-hidden="true"
            />
            {{ patient.fullName }}
          </span>
        </p>
      </div>
    </div>
    <div
      v-else
      class="patient-header blank"
    >
      <i
        class="fal fa-user-shield"
        aria-hidden="true"
      />
      <p>{{ $tc('component.patientFusion.searchPatientEmpty') }}</p>
    </div>
  </b-col>
</template>

<script>
export default {
    name: 'PatientHeaderCard',
    props: {
        patient: { type: Object, default: null },
        customClass: { type: Array }
    },
    methods: {
        patientTimeOld(patient) {
            return this.getPatientTimeOld(patient.patBirthdate)
        }
    }
}
</script>

<style lang="scss" scoped>
    .patient-header {
        p {
            margin-bottom: 0;
            margin-top: 5px;
            color: vt-color(dark-text);
        }

        &.blank {
            margin-top: 1rem;
            text-align: center;

            i {
                font-size: 70px;
                color: vt-color(base-text, .5);
            }
            p {
                margin-top: 20px;
                font-size: 14px;
                color: vt-color(base-text);
            }
        }
    }
</style>
